import {ParseResolver} from './interfaces/parse-resolver';

const SUPPORTED_STRINGS_REGEX = /^[A-Za-z0-9_]+(\(\))?(\.[A-Za-z0-9_]+(\(\))?)*$/;
const PLAIN_KEY_REGEX = /^[A-Za-z0-9]+$/;
const FUNCTION_CALL_REGEX = /^([A-Za-z0-9]+)\( *\)$/;

/**
 * ParseResolver was created to mimic what Angular 1 gave us in the $parse service.
 */
export class SimpleParseResolver implements ParseResolver {

  tokens: Array<{hash: string, isFunction: boolean}> = [];

  /**
   * @param parseText: an object lookup key that can contain functions or hash lookups.
   */
  constructor(parseText: string) {
    if (!SUPPORTED_STRINGS_REGEX.test(parseText)) {
      throw 'parseText not supported: ' + parseText;
    }

    parseText.split('.').forEach((textToken: string) => {
      if (PLAIN_KEY_REGEX.test(textToken)) {
        this.tokens.push({
          hash: textToken,
          isFunction: false
        });
      } else if (FUNCTION_CALL_REGEX.test(textToken)) {
        let pieces: RegExpExecArray | null = FUNCTION_CALL_REGEX.exec(textToken);
        if (pieces != null) {
          this.tokens.push({
            hash: pieces[1],
            isFunction: true
          });
        }
      }
    });
  }

  /**
   * resolves the parseText against the target object. Any references other
   * than the main reference are resolved against the context.
   * @param target - The object to resolve the parseText against.
   * @param context - The object to resolve any references inside the parseText against.
   * @returns {any}
   */
  resolve(target: any): any {
    let t: any = target;
    this.tokens.find((token: {hash: string, isFunction: boolean}) => {
      if (t == null) {
        //Make the looping stop.
        return true;
      }

      if (token.isFunction) {
        let fn = t[token.hash];
        //t is the object that points fn,
        //so that is the context we must call the function in.
        t = fn.call(t);
      } else {
        t = t[token.hash];
      }
      return false;
    });

    return t;
  }
}
